const fetchReceiptAction = (state, action) => {
    const { receipt } = action.payload;
    return {
        ...state,
        receiptId: receipt.transaction.receiptId,
        [`${receipt.transaction.receiptId}`]: {
            ...receipt,
        },
    };
};

export default fetchReceiptAction;
